import React, { Component } from 'react'
import '../../styles/GlobalStyle.css'
import { db } from '../../firebase/Firebase'
import ColType from '../.././Types'
//import { getIDFromURL, flattenDoc, getInitials } from '../.././Util'
import { Input, Button, Form, Tooltip, Modal, Select, message } from 'antd'
import PersonAvatar from '../../customcomponents/PersonAvatar'
const FormItem = Form.Item
const Option = Select.Option

const successMessage = (description) => {
    message.success(description)
}

const errorMessage = (description) => {
    message.error(description)
}


class EditGroupForm extends Component {
    constructor(props) {
        super(props)
        this.selectRef = React.createRef()
        this.state = {
            addGroupModalVisible: false,
            edittingGroup: false,
        }
    }

    componentWillUnmount() {
        if (this.selectRef &&
            this.selectRef.hasOwnProperty('rcSelect') &&
            this.selectRef.rcSelect &&
            this.selectRef.rcSelect.hasOwnProperty('inputRef') &&
            this.selectRef.rcSelect.inputRef) {
            this.selectRef.rcSelect.inputRef.removeEventListener("keydown", this.inputRefPreventKeydown)
        }
    }

    inputRefPreventKeydown = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }

    showModal = () => {
        let viewerIds = this.props.group.viewerIds.filter(viewerId => viewerId !== this.props.group.groupCreatedById)
        this.props.form.setFieldsValue({
            groupName: this.props.group.groupName,
            viewerIds: viewerIds,
        })

        this.setState({
            addGroupModalVisible: true,
        })
    }

    onGroupModalCancel = () => {
        this.setState({
            addGroupModalVisible: false,
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (!this.props.teacher) {
                    return
                }

                this.setState({
                    edittingGroup: true,
                })

                // make a copy, if you modify values.viewerIds
                // it shows up in the form as the form shares
                // the values.viewerIds list
                let viewerIdsCopy = []
                values.viewerIds.map((viewerId) => {
                    return viewerIdsCopy.push(viewerId)
                })
                viewerIdsCopy.push(this.props.teacher.id)

                db.collection(ColType.chatGroup)
                    .doc(this.props.group.id)
                    .update({
                        groupName: values.groupName,
                        viewerIds: viewerIdsCopy,
                    })
                    .then(() => {
                        successMessage("Group updated successfully.")
                        this.setState({
                            edittingGroup: false,
                            addGroupModalVisible: false,
                        }, () => {
                            // clear form
                            this.props.form.resetFields()
                        })
                        this.onGroupModalCancel()
                    })
                    .catch((e) => {
                        console.log(e)
                        errorMessage("Something went wrong. Try again or email support@dotit.app")
                        this.setState({
                            edittingGroup: false,
                        })
                    })
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }

        return (
            <span>
                <Tooltip
                    placement="bottomRight"
                    title="Team settings (change team name, invite more people to this team)"
                >
                    <Button shape="circle" icon="setting" size="large" className="mr-1 font-24"
                        onClick={this.showModal}
                    />
                </Tooltip>
                <Modal
                    title="Update team"
                    visible={this.state.addGroupModalVisible}
                    onCancel={this.onGroupModalCancel}
                    footer={null}
                >
                    <Form onSubmit={this.handleSubmit} className="block-label-form">
                        <FormItem {...formItemLayout} label="Team name">
                            {getFieldDecorator('groupName', {
                                rules: [{ required: true, message: 'Team name is required.' }],
                            })(
                                <Input placeholder="Team name..." size="large" />
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="People currently in this team (Click to invite more people)">
                            {getFieldDecorator('viewerIds', {
                                rules: [{ required: true, message: 'An invitation is required.' }],
                            })(
                                <Select size="large" mode="multiple" className="ant-select-vlg-options"
                                    ref={(el) => {
                                        this.selectRef = el
                                        if (this.selectRef &&
                                            this.selectRef.hasOwnProperty('rcSelect') &&
                                            this.selectRef.rcSelect &&
                                            this.selectRef.rcSelect.hasOwnProperty('inputRef') &&
                                            this.selectRef.rcSelect.inputRef) {
                                            // prevent user input in the select and hide the input cursor (this
                                            // is called once when the select is first rendered)
                                            this.selectRef.rcSelect.inputRef.classList.add("input-cursor-display-none")
                                            this.selectRef.rcSelect.inputRef.addEventListener("keydown", this.inputRefPreventKeydown)
                                        }
                                    }}>
                                    {Object.keys(this.props.schoolPersonnelDict).map((schoolId, idx) => {
                                        let schoolPersonnelDict = this.props.schoolPersonnelDict[schoolId]
                                        return <Select.OptGroup label={schoolPersonnelDict.school.schoolName} key={schoolId}>
                                            <Select.OptGroup label={<div>Teachers</div>} key={schoolId + '-teachers'}>
                                                {schoolPersonnelDict.teachers.map((teacher, idx) => {
                                                    // can't invite yourself (invited by default)
                                                    if (teacher.id === this.props.teacher.id) {
                                                        return false
                                                    }
                                                    return <Option key={teacher.id} value={teacher.id}>
                                                        <div className='flex flex-v-center w-100'>
                                                            <PersonAvatar
                                                                person={teacher}
                                                                size={'large'}
                                                                containerClassName="font-14 mr-1"
                                                                avatarClassName="font-14 font-bold mr-1"
                                                                personClassName="font-black font-14 ellipsis max-w-150"
                                                            />
                                                            <div className='ml-auto pr-1 font-14'>
                                                                {schoolPersonnelDict.school.schoolName}
                                                            </div>
                                                        </div>
                                                    </Option>
                                                })}
                                            </Select.OptGroup>
                                            <Select.OptGroup label={<div>Instructional and School Administrators</div>} key={schoolId + '-instructional-school-admins'}>
                                                {schoolPersonnelDict.instructionalFacilitators.concat(schoolPersonnelDict.schoolAdmins).map((teacher, idx) => {
                                                    // can't invite yourself (invited by default)
                                                    if (teacher.id === this.props.teacher.id) {
                                                        return false
                                                    }
                                                    return <Option key={teacher.id} value={teacher.id}>
                                                        <div className='flex flex-v-center w-100'>
                                                            <PersonAvatar
                                                                person={teacher}
                                                                size={'large'}
                                                                containerClassName="font-14"
                                                                avatarClassName="font-14 font-bold mr-1"
                                                                personClassName="font-black font-14 ellipsis max-w-150"
                                                            />
                                                            <div className='ml-auto pr-1 font-14'>
                                                                {schoolPersonnelDict.school.schoolName}
                                                            </div>
                                                        </div>
                                                    </Option>
                                                })}
                                            </Select.OptGroup>
                                        </Select.OptGroup>
                                    })}
                                </Select>
                            )}
                        </FormItem>
                        <FormItem className="mb-0">
                            <div className="flex">
                                <Button
                                    className="ant-btn ml-auto mr-1"
                                    onClick={this.onGroupModalCancel}
                                    size="large"
                                    disabled={this.state.edittingGroup}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    htmlType="submit"
                                    className="ant-btn ant-btn-primary"
                                    size="large"
                                    disabled={this.state.edittingGroup}
                                >
                                    {this.state.edittingGroup ? "Updating team..." : "Update team"}
                                </Button>
                            </div>
                        </FormItem>
                    </Form>
                </Modal>
            </span>
        )
    }
}

export default Form.create()(EditGroupForm)